import {
    IS_TRANS_LOADING,
    TRANS_HAS_ERROR,
    TRANS_FETCH_DATA_SUCCESS,
    IS_CONSTRAINTS_LOADING,
    CONSTRAINTS_HAS_ERROR,
    CONSTRAINTS_SUCCESS,
    RESET_API_ERROR,
    IS_RULES_LOADING,
    RULES_FETCH_DATA_SUCCESS,
    RULES_HAS_ERROR,
    SET_TOTAL_POINTS,
    LANDING_TRANS_SUCCESS,
    LANDING_TRANS_LOADING,
    LANDING_TRANS_ERROR,
    CLOSE_DYNAMIC_CARD,
} from './../constants/action-types';
import {translations, constraints, rules, landingTrans} from "../constants/api-url";
import config from '../config';
import common from './../common';

export function isTransLoading(bool) {
    return {
        type   : IS_TRANS_LOADING,
        payload: bool
    };
}

export function hasError(bool) {
    return {
        type   : TRANS_HAS_ERROR,
        payload: bool
    };
}

export function fetchDataSuccess(trans) {
    return {
        type   : TRANS_FETCH_DATA_SUCCESS,
        payload: trans
    };
}

export function isConstraintsLoading(bool) {
    return {
        type   : IS_CONSTRAINTS_LOADING,
        payload: bool
    };
}

export function constraintsDataSuccess(trans) {
    return {
        type   : CONSTRAINTS_SUCCESS,
        payload: trans
    };
}

export function constraintsHasError(bool) {
    return {
        type   : CONSTRAINTS_HAS_ERROR,
        payload: bool
    };
}

export function isRulesLoading(bool) {
    return {
        type   : IS_RULES_LOADING,
        payload: bool
    };
}

export function rulesDataSuccess(trans) {
    return {
        type   : RULES_FETCH_DATA_SUCCESS,
        payload: trans
    };
}

export function rulesHasError(bool) {
    return {
        type   : RULES_HAS_ERROR,
        payload: bool
    };
}

export function resetAPIPError() {
    return {
        type   : RESET_API_ERROR,
        payload: null
    };
}

export function setTotalScore(points) {
    return {
        type   : SET_TOTAL_POINTS,
        payload: points
    };
}

export function isLandingTransLoading(){
    return{
        type : LANDING_TRANS_LOADING,
        payload : null
    }
}

export function landingTransSuccess(trans){
    return{
        type : LANDING_TRANS_SUCCESS,
        payload : trans
    }
}

export function landingTransError(){
    return{
        type : LANDING_TRANS_ERROR,
        payload : null
    }
}

export function transFetchData() {
    const params = {platformId: config.PLATFORM_ID, languageCode: config.CURRENT_LANGUAGE};
    let clientname = common.getClientNameFromLandingURL();
    let transURL = translations
    return (dispatch) => common.makeAPICall(transURL, dispatch, isTransLoading, fetchDataSuccess, hasError, params);
}

export function constraintsFetchData() {
    return (dispatch) => common.makeAPICall(constraints, dispatch, isConstraintsLoading, constraintsDataSuccess, constraintsHasError);
}

export function rulesFetchData() {
    const params = {languageCode: config.CURRENT_LANGUAGE};
    return (dispatch) => common.makeAPICall(rules, dispatch, isRulesLoading, rulesDataSuccess, rulesHasError, params);
}

export function getLandingTrans(){
    const params = {}
    let clientname = common.getClientNameFromLandingURL();
    let transURL = landingTrans.replace('{clientName}', clientname).replace('{lang}', config.CURRENT_LANGUAGE)
    return (dispatch) => {common.makeAPICall(transURL, dispatch, isLandingTransLoading, landingTransSuccess, landingTransError, params)}
}


export function closeDynamicCard(dynamicCard) {
    return {
        type   : CLOSE_DYNAMIC_CARD,
        payload: dynamicCard
    };
}


// WEBPACK FOOTER //
// ./src/actions/AppActions.js